import callAPI from "../callApi";
import path from "../variables";

const Boarding = {
	markNoShow: (data: any) =>
		callAPI("POST", `${path.base}/boarding/no-show`, data, "marking no-show"),
	addToStandby: (data: any) =>
		callAPI("POST", `${path.base}/boarding/standby/add`, data, "adding to standby"),
	promoteStandby: (data: any) =>
		callAPI("POST", `${path.base}/boarding/standby/promote`, data, "promoting standby"),
	standbyList: (filter?: string) =>
		callAPI("GET", `${path.base}/boarding/standby/list${filter || ""}`, "", "getting standby list"),
};

export default Boarding;
